import { __decorate } from "tslib";
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VALIDATION_RULES } from "@/constants/ValidationRules";
import { INPUT_TYPES } from "@/constants/InputTypes";
import SimpleCrud from "@/components/SimpleCrud.vue";
import moment from "moment";
let Vouchers = class Vouchers extends Vue {
    title = 'Poukazy';
    storeModule = 'voucher';
    formAddTitle = 'Nový poukaz';
    formEditTitle = 'Upravit poukaz';
    headers = [
        {
            text: 'Kód',
            value: 'data.code',
            rules: [],
            type: INPUT_TYPES.TEXT,
            notEditable: true,
        },
        {
            text: 'Převzal',
            value: 'data.owner',
            rules: [VALIDATION_RULES.REQUIRED],
            type: INPUT_TYPES.TEXT,
            readOnly: true,
        },
        {
            text: 'Cena',
            value: 'data.price',
            rules: [VALIDATION_RULES.REQUIRED, VALIDATION_RULES.UNSIGNED_NUMBER],
            type: INPUT_TYPES.NUMBER,
            readOnly: true,
        },
        {
            text: 'Hodnota',
            value: 'data.value',
            rules: [VALIDATION_RULES.REQUIRED, VALIDATION_RULES.POSITIVE_NUMBER],
            type: INPUT_TYPES.NUMBER,
            readOnly: true,
        },
        {
            text: 'Zbývající hodnota',
            value: 'data.remainingValue',
            rules: [],
            type: INPUT_TYPES.NUMBER,
            notEditable: true,
        },
        {
            text: 'Platnost do',
            value: 'data.validTo',
            rules: [VALIDATION_RULES.DATE_AFTER],
            type: INPUT_TYPES.DATE,
        },
        {
            text: '',
            value: 'actions',
            rules: [],
            type: '',
            sortable: false,
            notEditable: true,
        },
    ];
    defaultItem = {
        id: 'new-voucher',
        data: {
            code: '',
            owner: '',
            value: 500,
            remainingValue: 500,
            price: 500,
            validTo: moment().add(1, 'year').year() + '-05-31',
            active: true,
            deletedAt: null,
        },
    };
    get userLoggedIn() {
        return this.$store.getters['user/isLoggedIn'];
    }
    async saved(voucher) {
        // TODO get saved voucher code
        // const validTo = moment(voucher.data.validTo);
        // await ConfirmDialog.open(
        //     voucher.id === this.defaultItem.id ? 'Nový voucher' : 'Voucher změněn',
        //     `
        //         Kód: "${voucher.data.code}"<br>
        //         Platnost do: ${validTo.format('D. M. YYYY')}<br>
        //         Prodejní cena voucheru: ${voucher.data.price},- Kč<br>
        //         Původní hodnota voucheru: ${voucher.data.value},- Kč<br>
        //         Zbývající hodnota voucheru: ${voucher.data.remainingValue},- Kč
        //     `,
        //     'Ok',
        //     'Zavřít'
        // );
    }
};
Vouchers = __decorate([
    Component({
        components: { SimpleCrud },
    })
], Vouchers);
export default Vouchers;
